
.OuterTable {
    position: relative;
    overflow: hidden;
    max-height: 100%;
    min-height: 11rem;
}
